import React, { Component, Fragment } from 'react'
import { Query, withApollo } from 'react-apollo'
import gql from 'graphql-tag'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Typography from '@material-ui/core/Typography'
import {
  withStyles,
  createMuiTheme,
  MuiThemeProvider
} from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Divider from '@material-ui/core/Divider'
import { DatePicker } from 'material-ui-pickers'
import getAccountType from '../../../utils/getAccountType'
import withRouter from 'react-router-dom/withRouter'
import moment from 'moment'
import Loader from '../../common/Loader'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import PaymentMethod from '../ViewSubscription/PaymentMethod'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import MUIDataTable from 'mui-datatables'

const GET_PARTNER_SUBSCRIPTION = gql`
  query getPartnerSubscriptions($id: Int!) {
    partnerSubscription: getPartnerSubscriptions(id: $id) {
      id
      partnerLoginId
      status
      createdAt
      salesRemarks
      gst
      partnerDetail {
        id
        businessName
      }
      billingFrequency {
        id
        frequency
      }
      noOfDevices
      nextPaymentDate
      totalSoftwareQty
      unassignedDeviceQuantity
      unassignedSimQty
      unassignedAccessoryQty
      deviceTrackingCharges
      billingMode {
        id
        billingMode
      }
      billingDetails {
        paymentId
        totalAmount
        totalAmountWithGST
        softwareBill {
          quantity
          rate
          amountWithGST
          amountToBePaid
          amountPaidGST
        }
        hardwareBill {
          quantity
          rate
          amountWithGST
          amountToBePaid
          amountPaidGST
        }
        accessoryBill {
          quantity
          rate
          amountWithGST
          amountToBePaid
          amountPaidGST
        }
        simBill {
          quantity
          rate
          amountWithGST
          amountToBePaid
          amountPaidGST
        }
      }
    }
  }
`

const APPROVE_REJECT_PARTNER_SUBSCRIPTION = gql`
  mutation(
    $partnerLoginId: Int!
    $paymentId: Int!
    $partnerSubscriptionId: Int!
    $approveOrReject: approveOrReject!
    $paidDetails: inputBillingDetails
    $paymentMode: paymentMode
    $bankName: String
    $referenceNumber: String
    $accountsRemarks: String
  ) {
    approveOrRejectPartnerSubscription(
      partnerLoginId: $partnerLoginId
      paymentId: $paymentId
      partnerSubscriptionId: $partnerSubscriptionId
      approveOrReject: $approveOrReject
      paidDetails: $paidDetails
      paymentMode: $paymentMode
      bankName: $bankName
      referenceNumber: $referenceNumber
      accountsRemarks: $accountsRemarks
    )
  }
`

const styles = theme => ({
  containerStyle: {
    margin: '0 2%'
  },
  rowStyle: {
    margin: '15px 0'
  },
  textFieldStyle: {
    width: '55%'
  },
  dateStyle: {
    width: '50%'
  },
  subHeadingStyle: {
    marginLeft: '1.9vw',
    marginBottom: '10px',
    fontSize: '1rem',
    fontWeight: 'bold'
  },
  cardAction: {
    marginLeft: '-1.9vw'
  },
  selectStyle: {
    minWidth: 250
  },
  redButton: {
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.dark
    }
  }
})

const paymentOption = ['NONE', 'CASH', 'ONLINE', 'CHEQUE', 'DD']

class PartnerSubscriptionDetail extends Component {
  state = {
    partnerLoginId: 0,
    partnerSubscriptionData: null,
    hardwarePaymentMade: 0,
    softwarePaymentMade: 0,
    accessoryPaymentMade: 0,
    simPaymentMade: 0,
    paymentId: 0,
    hardwareBalance: 0,
    softwareBalance: 0,
    accessoryBalance: 0,
    simBalance: 0,
    hardwareRemarks: null,
    softwareRemarks: null,
    accessoryRemarks: null,
    simRemarks: null,
    // expectedHardwareDueDate: moment()
    //   .add(7, 'days')
    //   .format('DD-MM-YYYY'),
    expectedHardwareDueDate: moment().add(1, 'weeks'),
    expectedSoftwareDueDate: moment().add(1, 'weeks'),
    expectedAccessoryDueDate: moment().add(1, 'weeks'),
    expectedSimsDueDate: moment().add(1, 'weeks'),
    approveOrReject: null,
    isLoading: true,
    paymentMode: '',
    referenceNumber: null,
    bankName: null,
    isEditButton: true,
    isValidReferenceNumber: true,
    referenceMessage: '',
    allInvoiceData: []
  }

  getFormattedDate = date1 => {
    const d1 = parseInt(date1, 10)
    const unixEpochTimeMS = d1 * 1000
    const d = new Date(unixEpochTimeMS)
    // Careful, the string output here can vary by implementation...
    const strDate = d.toLocaleDateString()
    return strDate
  }

  handleEditSubcription = () => {
    // console.log('this.props.location', this.props.match.params)
    this.props.history.push({
      pathname: `/home/partner/view/${this.props.match.params.loginId}/${
        this.props.match.params.subscriptionId
      }/partnerSubscriptionEdit`
    })
  }

  handlePaymentMade = name => event => {
    const { value } = event.target
    if (value >= 0) {
      this.setState({ [name]: value }, () => {
        this.calculateBalance(name)
      })
    }
  }

  calculateBalance = particularName => {
    const {
      hardwarePaymentMade,
      softwarePaymentMade,
      accessoryPaymentMade,
      simPaymentMade
    } = this.state
    const { partnerSubscriptionData } = this.state
    const {
      billingDetails: { hardwareBill, softwareBill, accessoryBill, simBill }
    } = partnerSubscriptionData
    // console.log('balance calculating:', particularName)
    let balanceAmount = 0
    if (particularName === 'hardwarePaymentMade') {
      balanceAmount = hardwareBill.amountWithGST - hardwarePaymentMade
      this.setState({ hardwareBalance: balanceAmount })
    }
    if (particularName === 'softwarePaymentMade') {
      balanceAmount = softwareBill.amountWithGST - softwarePaymentMade
      this.setState({ softwareBalance: balanceAmount })
    }
    if (particularName === 'accessoryPaymentMade') {
      balanceAmount = accessoryBill.amountWithGST - accessoryPaymentMade
      this.setState({ accessoryBalance: balanceAmount })
    }
    if (particularName === 'simPaymentMade') {
      balanceAmount = simBill.amountWithGST - simPaymentMade
      this.setState({ simBalance: balanceAmount })
    }
  }

  handleRemarksChange = name => event => {
    const { value } = event.target
    this.setState({ [name]: value })
  }

  handleExpectedDateChange = name => date => {
    this.setState({ [name]: date })
  }

  handleChangePaymentType = event => {
    this.setState({
      paymentMode: event.target.value,
      isValidReferenceNumber: true,
      referenceMessage: '',
      referenceNumber: null,
      bankName: null
    })
  }

  handleChangeReferenceNumber = event => {
    console.log('reference number', typeof event.target.value)
    this.setState({ referenceNumber: event.target.value })
  }

  checkReferenceNumberValidity = () => {
    let regExValue = new RegExp(
      /(^[a-zA-Z0-9]{6,15})|(^[0-9]{6,15})|(^[a-zA-Z]{6,15})|(?!)$/
    )

    if (this.state.referenceNumber === null) {
      this.setState({
        isValidReferenceNumber: true,
        referenceMessage: 'Please enter Reference/DD/Check number'
      })
    } else if (
      regExValue.test(this.state.referenceNumber) &&
      this.state.referenceNumber !== ' '
    ) {
      this.setState({
        isValidReferenceNumber: true,
        referenceMessage: ''
      })
    } else if (this.state.referenceNumber === '') {
      this.setState({
        isValidReferenceNumber: false,
        referenceMessage: 'Please enter Reference/DD/Check number'
      })
    } else {
      this.setState({
        isValidReferenceNumber: false,
        referenceMessage: 'Please enter a valid Reference/DD/Check number'
      })
    }
  }

  // handleChangePaidMoney = event => {
  //   this.setState({ paidMoney: event.target.value })
  // }

  handleChangeBankName = event => {
    this.setState({ bankName: event.target.value })
  }

  assignDevice = () => {
    this.props.history.push({
      pathname: `/home/partnerSubscriptions/assign/${
        this.props.match.params.loginId
      }/${this.props.match.params.subscriptionId}`
    })
  }

  validateFields = () => {
    // console.log('this.state.paymentModeff', this.state.paymentMode)
    const {
      hardwarePaymentMade,
      softwarePaymentMade,
      simPaymentMade,
      accessoryPaymentMade
    } = this.state

    // console.log('meena', this.state.paidMoney, this.state.paymentMode)
    if (hardwarePaymentMade === '') {
      this.props.openSnackbar('Hardware payment made should not be blank!')
      return false
    } else if (softwarePaymentMade === '') {
      this.props.openSnackbar('Software payment made should not be blank!')
      return false
    } else if (accessoryPaymentMade === '') {
      this.props.openSnackbar('Accessory payment made should not be blank!')
      return false
    } else if (simPaymentMade === '') {
      this.props.openSnackbar('Sim payment made should not be blank!')
      return false
    } else if (
      this.state.hardwarePaymentMade === 0 &&
      this.state.softwarePaymentMade === 0 &&
      this.state.accessoryPaymentMade === 0 &&
      this.state.simPaymentMade === 0 &&
      this.state.paymentMode !== 'NONE'
    ) {
      this.props.openSnackbar(
        'Please Select NONE option if you are not paying any amount!'
      )
      return false
    } else if (
      (this.state.hardwarePaymentMade > 0 ||
        this.state.softwarePaymentMade > 0 ||
        this.state.accessoryPaymentMade > 0 ||
        this.state.simPaymentMade > 0) &&
      this.state.paymentMode === 'NONE'
    ) {
      this.props.openSnackbar(
        'Please select valid  payment option if you are making payment!'
      )
      return false
    } else if (this.state.paymentMode === 'ONLINE') {
      if (
        this.state.referenceNumber === null ||
        this.state.referenceNumber === ''
      ) {
        this.props.openSnackbar('Reference Number Should not be blank')
        this.setState({ validation: false })
        return false
      } else {
        this.setState({ validation: true })
        return true
      }
    } else if (
      this.state.paymentMode === 'DD' ||
      this.state.paymentMode === 'CHEQUE'
    ) {
      if (
        this.state.referenceNumber === null ||
        this.state.referenceNumber === ''
      ) {
        this.props.openSnackbar('Reference Number Should not blank!')
        this.setState({ validation: false })
        return false
      } else if (this.state.bankName === null) {
        this.props.openSnackbar('Bank Name Should not blank!')
        this.setState({ validation: false })
        return false
      } else {
        this.setState({ validation: true })
        return true
      }
    } else {
      this.setState({ validation: true })
      return true
    }
  }

  handleRejectMutation = async () => {
    const { data } = await this.props.client.mutate({
      mutation: APPROVE_REJECT_PARTNER_SUBSCRIPTION,
      variables: {
        partnerLoginId: parseInt(this.state.partnerLoginId, 10),
        paymentId: parseInt(this.state.paymentId, 10),
        partnerSubscriptionId: parseInt(
          this.props.match.params.subscriptionId,
          10
        ),
        approveOrReject: this.state.approveOrReject,
        accountsRemarks: this.state.accountRemarks
      }
    })
    const { approveOrRejectPartnerSubscription } = data
    if (approveOrRejectPartnerSubscription) {
      this.props.openSnackbar('Subscription Rejected')
      this.props.history.goBack()
    }
  }

  handleCancel = () => {
    this.setState({ approveOrReject: 'REJECTED' }, () => {
      this.handleRejectMutation()
    })
  }

  handleApproveMutation = async () => {
    const { data } = await this.props.client.mutate({
      mutation: APPROVE_REJECT_PARTNER_SUBSCRIPTION,
      variables: {
        partnerLoginId: parseInt(this.state.partnerLoginId, 10),
        partnerSubscriptionId: parseInt(
          this.props.match.params.subscriptionId,
          10
        ),
        paidDetails: {
          hardwareBill: {
            amountWithGST: parseInt(this.state.hardwarePaymentMade, 10),
            expectedDateTime: moment(this.state.expectedSoftwareDueDate)
              .unix()
              .toString(),
            accountsRemrks: this.state.hardwareRemarks
          },
          softwareBill: {
            amountWithGST: parseInt(this.state.softwarePaymentMade, 10),
            expectedDateTime: moment(this.state.expectedHardwareDueDate)
              .unix()
              .toString(),
            accountsRemrks: this.state.softwareRemarks
          },
          accessoryBill: {
            amountWithGST: parseInt(this.state.accessoryPaymentMade, 10),
            expectedDateTime: moment(this.state.expectedAccessoryDueDate)
              .unix()
              .toString(),
            accountsRemrks: this.state.accessoryRemarks
          },
          simBill: {
            amountWithGST: parseInt(this.state.simPaymentMade, 10),
            expectedDateTime: moment(this.state.expectedSimsDueDate)
              .unix()
              .toString(),
            accountsRemrks: this.state.simRemarks
          }
        },
        paymentMode: this.state.paymentMode,
        paymentId: parseInt(this.state.paymentId, 10),
        bankName: this.state.bankName,
        referenceNumber: this.state.referenceNumber,
        accountsRemarks: this.state.accountRemarks,
        approveOrReject: this.state.approveOrReject
      }
    })

    const { approveOrRejectPartnerSubscription } = data
    if (approveOrRejectPartnerSubscription) {
      this.props.openSnackbar(' Subscription Approved')
      this.props.history.goBack()
    }
  }

  handleSubmit = () => {
    if (this.validateFields()) {
      this.setState({ approveOrReject: 'APPROVED' }, () => {
        this.handleApproveMutation()
      })
    }
  }

  setInitialBalanceAndEditBooleans = () => {
    const { partnerSubscriptionData } = this.state
    if (partnerSubscriptionData.billingDetails) {
      const {
        hardwareBill,
        softwareBill,
        accessoryBill,
        simBill
      } = partnerSubscriptionData.billingDetails
      if (hardwareBill) {
        this.setState({ hardwareBalance: hardwareBill.amountWithGST })
      }
      if (softwareBill) {
        this.setState({ softwareBalance: softwareBill.amountWithGST })
      }
      if (accessoryBill) {
        this.setState({ accessoryBalance: accessoryBill.amountWithGST })
      }
      if (simBill) {
        this.setState({ simBalance: simBill.amountWithGST })
      }
    }
    if (
      partnerSubscriptionData.status === 1 ||
      partnerSubscriptionData.status === 3 ||
      partnerSubscriptionData.status === 4
    ) {
      this.setState({ isEditButton: false })
    } else {
      this.setState({ isEditButton: true })
    }
  }

  getPartnerSubscriptionData = async () => {
    const { data, loading, error } = await this.props.client.query({
      query: GET_PARTNER_SUBSCRIPTION,
      variables: {
        id: parseInt(this.props.match.params.subscriptionId, 10)
        // id: 23
      },
      fetchPolicy: 'network-only'
    })
    // console.log('lladong', loading, data, error)
    if (!loading) {
      this.setState(
        {
          isLoading: loading,
          partnerSubscriptionData: data.partnerSubscription
        },
        () => {
          this.setInitialBalanceAndEditBooleans()
          this.getPaymentAndPartnerLogInId()
        }
      )
      // console.log('hh', data.partnerSubscription)
    }
  }

  getPaymentAndPartnerLogInId = () => {
    const { partnerSubscriptionData } = this.state
    // console.log('partnerSubscriptionData', partnerSubscriptionData)
    if (partnerSubscriptionData.billingDetails !== null) {
      this.setState({
        paymentId: partnerSubscriptionData.billingDetails.paymentId
      })
    } else {
      this.setState({ paymentId: 0 })
    }
    this.setState({ partnerLoginId: partnerSubscriptionData.partnerLoginId })
  }

  componentDidMount = () => {
    this.getPartnerSubscriptionData()
  }
  getStatusType = status => {
    // console.log(getAccountType(), status, 'alllll')
    if (status === 1 || status === 4) {
      return 'Pending'
    } else if (status === 2 || status === 5) {
      return 'Approved'
    } else if (status === 3) {
      return 'Rejected'
    }
  }
  getGst = Gst => {
    return Gst * 100
  }
  handleAccountRemarksChange = e => {
    this.setState({ accountRemarks: e.target.value })
  }

  render() {
    const { classes } = this.props
    const { isLoading, partnerSubscriptionData } = this.state
    // console.log('loading', this.state.partnerSubscriptionData, isLoading)

    // let isTrue = isOne && isTwo ? 'True' : 'false'
    // let isFalse = isTwo ? 'true' : 'false'
    console.log(
      partnerSubscriptionData,
      '======',
      this.state.expectedSoftwareDueDate,
      this.state.expectedHardwareDueDate
    )

    const {
      hardwarePaymentMade,
      softwarePaymentMade,
      accessoryPaymentMade,
      simPaymentMade,
      hardwareBalance,
      softwareBalance,
      accessoryBalance,
      simBalance,
      // hardwareRemarks,
      // softwareRemarks,
      // accessoryRemarks,
      // simRemarks,
      expectedHardwareDueDate,
      expectedSoftwareDueDate,
      expectedAccessoryDueDate,
      expectedSimsDueDate,
      isEditButton
    } = this.state

    return (
      <Fragment>
        {isLoading ? (
          <Loader />
        ) : (
          <Grid className={classes.containerStyle}>
            <br />
            <Grid item xs={12}>
              <Grid container justify="space-between">
                <Grid item className={classes.gridItemHorizontal}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    className={classes.button}
                    onClick={() => this.props.history.goBack()}
                  >
                    <ArrowBackIcon className={classes.iconSmall} />
                  </Button>
                </Grid>
                {/* eslint-disable */}
                <Grid item className={classes.gridItemHorizontal}>
                  {!['INV', 'ACC'].includes(getAccountType()) &&
                    isEditButton && (
                      <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        onClick={this.handleEditSubcription}
                      >
                        Edit
                      </Button>
                    )}
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="display1">
                  &nbsp;
                  {partnerSubscriptionData.partnerDetail.businessName}
                </Typography>
              </Grid>
            </Grid>

            <br />
            <Grid item xs={12}>
              <Card raised>
                <CardHeader
                  classes={{ action: classes.cardAction }}
                  // title={partnerSubscriptionData.partnerDetail.businessName}
                  title={partnerSubscriptionData.billingFrequency.frequency}
                  subheader={
                    partnerSubscriptionData
                      ? this.getFormattedDate(partnerSubscriptionData.createdAt)
                      : 'N/A'
                  }
                  action={
                    <Fragment>
                      <Typography
                        variant="body1"
                        style={{ fontSize: '20px', paddingTop: '10%' }}
                      >
                        <span style={{ opacity: '.6' }}>Status:</span>{' '}
                        {partnerSubscriptionData
                          ? this.getStatusType(partnerSubscriptionData.status)
                          : 'N/A'}
                      </Typography>
                    </Fragment>
                  }
                />
                <CardContent>
                  {/* eslint-disable */}
                  <Grid container spacing={16}>
                    <Grid item xs={6} sm={4}>
                      <Typography variant="body2">Quantity:</Typography>
                      <Typography variant="body1">
                        {partnerSubscriptionData.totalSoftwareQty}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} sm={4}>
                      <Typography variant="body2">MMTC:</Typography>
                      <Typography variant="body1">
                        &#8377;
                        {partnerSubscriptionData.totalSoftwareQty > 0
                          ? partnerSubscriptionData.deviceTrackingCharges +
                            ' /-'
                          : 'N/A'}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} sm={4}>
                      <Typography variant="body2">
                        Un-assigned Quantity
                      </Typography>
                      <Typography variant="body1">
                        {partnerSubscriptionData.noOfDevices}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} sm={4}>
                      <Typography variant="body2">
                        Next Payment Date:
                      </Typography>
                      <Typography variant="body1">
                        {moment
                          .unix(
                            parseInt(
                              partnerSubscriptionData.nextPaymentDate,
                              10
                            )
                          )
                          .format('DD/MM/YYYY')}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} sm={4}>
                      <Typography variant="body2">Bill Mode:</Typography>
                      <Typography variant="body1">
                        {partnerSubscriptionData.billingMode.billingMode}
                      </Typography>
                    </Grid>

                    {/* {!['SER', 'INV'].includes(getAccountType()) && (
                      <Grid item xs={6} sm={4}>
                        <Typography variant="body2">
                          Min. Amount Due:
                        </Typography>
                        <Typography variant="body1">
                          {partnerSubscriptionData.totalAmountWithGST}
                        </Typography>
                      </Grid>
                    )} */}

                    <Grid item xs={6} sm={4}>
                      <Typography variant="body2">Sales Remarks:</Typography>
                      <Typography variant="body1">
                        {partnerSubscriptionData.salesRemarks
                          ? partnerSubscriptionData.salesRemarks
                          : 'N/A'}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} sm={4}>
                      <Typography variant="body2">
                        Total Amount (Incl. GST)
                      </Typography>
                      <Typography variant="body1">
                        &#8377;
                        {partnerSubscriptionData.billingDetails
                          ? partnerSubscriptionData.billingDetails
                              .totalAmountWithGST
                          : 'N/A'}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} sm={4}>
                      <Typography variant="body2">GST Rate:</Typography>
                      <Typography variant="body1">
                        {partnerSubscriptionData.gst
                          ? this.getGst(partnerSubscriptionData.gst)
                          : 'N/A'}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
                <cardAction>
                  {
                    /* eslint-disable indent */
                    // ['SA'].includes(getAccountType()) &&
                    //   (partnerSubscriptionData.unassignedDeviceQuantity > 0 ||
                    //     partnerSubscriptionData.unassignedSimQty > 0 ||
                    //     partnerSubscriptionData.unassignedAccessoryQty > 0) &&
                    //   this.getStatusType(partnerSubscriptionData.status) ===
                    //     'Approved' && (
                    //     <Typography variant="body1">
                    //       <Button
                    //         color="secondary"
                    //         onClick={() => this.assignDevice(this.backUrl)}
                    //       >
                    //         Assign Device
                    //       </Button>
                    //     </Typography>
                    //   )
                    /* eslint-enable indent */
                  }
                </cardAction>
              </Card>
            </Grid>

            <br />

            <Grid item xs={12}>
              {partnerSubscriptionData.billingDetails && (
                <Card raised>
                  <CardContent>
                    <CardHeader
                      className={classes.cardAction}
                      title="Billing Details"
                    />
                    {/* Billing Details Body */}
                    <Grid container justify="space-between">
                      {/* Column Header Section  */}
                      <Grid item style={{ marginRight: '7vw' }}>
                        <Grid
                          container
                          direction="column"
                          alignContent="space-between"
                        >
                          <Grid item className={classes.rowStyle}>
                            <Typography variant="body2">PARTICULARS</Typography>
                          </Grid>
                          <Grid item className={classes.rowStyle}>
                            <Typography variant="body2"> Quantity</Typography>
                          </Grid>
                          <Grid item className={classes.rowStyle}>
                            <Typography variant="body2"> Price/item</Typography>
                          </Grid>
                          <Grid item className={classes.rowStyle}>
                            <Typography variant="body2">
                              {' '}
                              Total Amount(Incl. GST)
                            </Typography>
                          </Grid>
                          <Grid item className={classes.rowStyle}>
                            <Typography variant="body2">
                              {' '}
                              Amount paid(Incl. GST)
                            </Typography>
                          </Grid>
                          <Grid item className={classes.rowStyle}>
                            <Typography variant="body2">
                              {' '}
                              Amount to be paid(Incl. GST)
                            </Typography>
                          </Grid>
                          <Grid item className={classes.rowStyle}>
                            {['ACC'].includes(getAccountType()) && (
                              <Typography variant="body2">
                                {' '}
                                Payment Made
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>

                      {/*  Hardware Column Data */}
                      {partnerSubscriptionData.billingDetails.hardwareBill && (
                        <Grid item>
                          <Grid
                            container
                            direction="column"
                            alignContent="space-between"
                          >
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body2"> HARDWARE</Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                {' '}
                                {
                                  partnerSubscriptionData.billingDetails
                                    .hardwareBill.quantity
                                }
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                &#8377;{' '}
                                {
                                  partnerSubscriptionData.billingDetails
                                    .hardwareBill.rate
                                }
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                &#8377;{' '}
                                {
                                  partnerSubscriptionData.billingDetails
                                    .hardwareBill.amountWithGST
                                }
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                &#8377;{' '}
                                {
                                  partnerSubscriptionData.billingDetails
                                    .hardwareBill.amountPaidGST
                                }
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                &#8377;{' '}
                                {
                                  partnerSubscriptionData.billingDetails
                                    .hardwareBill.amountToBePaid
                                }
                              </Typography>
                            </Grid>
                            {['ACC'].includes(getAccountType()) && (
                              <Grid item className={classes.rowStyle}>
                                &#8377;{' '}
                                <TextField
                                  disabled={['SA'].includes(getAccountType())}
                                  id="amount"
                                  type="Number"
                                  className={classes.textFieldStyle}
                                  label="Paid Amount *"
                                  inputProps={{ min: 0 }}
                                  value={hardwarePaymentMade}
                                  onChange={this.handlePaymentMade(
                                    'hardwarePaymentMade'
                                  )}
                                  margin="none"
                                />
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      )}

                      {/*  Software Column Data */}
                      {partnerSubscriptionData.billingDetails.softwareBill && (
                        <Grid item>
                          <Grid
                            container
                            direction="column"
                            alignContent="space-between"
                          >
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body2"> SOFTWARE</Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                {' '}
                                {
                                  partnerSubscriptionData.billingDetails
                                    .softwareBill.quantity
                                }
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                &#8377;{' '}
                                {
                                  partnerSubscriptionData.billingDetails
                                    .softwareBill.rate
                                }
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                &#8377;{' '}
                                {
                                  partnerSubscriptionData.billingDetails
                                    .softwareBill.amountWithGST
                                }
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                &#8377;{' '}
                                {
                                  partnerSubscriptionData.billingDetails
                                    .softwareBill.amountPaidGST
                                }
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                &#8377;{' '}
                                {
                                  partnerSubscriptionData.billingDetails
                                    .softwareBill.amountToBePaid
                                }
                              </Typography>
                            </Grid>
                            {['ACC'].includes(getAccountType()) && (
                              <Grid item className={classes.rowStyle}>
                                &#8377;{' '}
                                <TextField
                                  disabled={['SA'].includes(getAccountType())}
                                  id="amount"
                                  type="Number"
                                  className={classes.textFieldStyle}
                                  label="Paid Amount *"
                                  inputProps={{ min: 0 }}
                                  value={softwarePaymentMade}
                                  onChange={this.handlePaymentMade(
                                    'softwarePaymentMade'
                                  )}
                                  margin="none"
                                />
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      )}

                      {/*  Accessory Column Data */}
                      {partnerSubscriptionData.billingDetails.accessoryBill && (
                        <Grid item>
                          <Grid
                            container
                            direction="column"
                            alignContent="space-between"
                          >
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body2">
                                {' '}
                                ACCESSORY
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                {' '}
                                {
                                  partnerSubscriptionData.billingDetails
                                    .accessoryBill.quantity
                                }
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                &#8377;{' '}
                                {
                                  partnerSubscriptionData.billingDetails
                                    .accessoryBill.rate
                                }
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                &#8377;{' '}
                                {
                                  partnerSubscriptionData.billingDetails
                                    .accessoryBill.amountWithGST
                                }
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                &#8377;{' '}
                                {
                                  partnerSubscriptionData.billingDetails
                                    .accessoryBill.amountPaidGST
                                }
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                &#8377;{' '}
                                {
                                  partnerSubscriptionData.billingDetails
                                    .accessoryBill.amountToBePaid
                                }
                              </Typography>
                            </Grid>
                            {['ACC'].includes(getAccountType()) && (
                              <Grid item className={classes.rowStyle}>
                                &#8377;{' '}
                                <TextField
                                  disabled={['SA'].includes(getAccountType())}
                                  id="amount"
                                  type="Number"
                                  className={classes.textFieldStyle}
                                  label="Paid Amount *"
                                  inputProps={{ min: 0 }}
                                  value={accessoryPaymentMade}
                                  onChange={this.handlePaymentMade(
                                    'accessoryPaymentMade'
                                  )}
                                  margin="none"
                                />
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      )}

                      {/*  Sims Column Data */}
                      {partnerSubscriptionData.billingDetails.simBill && (
                        <Grid item>
                          <Grid
                            container
                            direction="column"
                            alignContent="space-between"
                          >
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body2"> SIMS</Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                {' '}
                                {
                                  partnerSubscriptionData.billingDetails.simBill
                                    .quantity
                                }
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                &#8377;{' '}
                                {
                                  partnerSubscriptionData.billingDetails.simBill
                                    .rate
                                }
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                &#8377;{' '}
                                {
                                  partnerSubscriptionData.billingDetails.simBill
                                    .amountWithGST
                                }
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                &#8377;{' '}
                                {
                                  partnerSubscriptionData.billingDetails.simBill
                                    .amountPaidGST
                                }
                              </Typography>
                            </Grid>
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body1">
                                &#8377;{' '}
                                {
                                  partnerSubscriptionData.billingDetails.simBill
                                    .amountToBePaid
                                }
                              </Typography>
                            </Grid>
                            {['ACC'].includes(getAccountType()) && (
                              <Grid item className={classes.rowStyle}>
                                &#8377;{' '}
                                <TextField
                                  disabled={['SA'].includes(getAccountType())}
                                  id="amount"
                                  type="Number"
                                  className={classes.textFieldStyle}
                                  label="Paid Amount *"
                                  inputProps={{ min: 0 }}
                                  value={simPaymentMade}
                                  onChange={this.handlePaymentMade(
                                    'simPaymentMade'
                                  )}
                                  margin="none"
                                />
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                  </CardContent>
                </Card>
              )}
            </Grid>
            <br />
            {/* eslint-disable */}
            <Grid item xs={12}>
              {partnerSubscriptionData.billingDetails &&
                ['ACC'].includes(getAccountType()) && (
                  <Card>
                    <CardContent>
                      <CardHeader
                        className={classes.cardAction}
                        title="Credit Notes"
                      />
                      {/* Credit Note Section */}
                      <Grid container justify="space-between">
                        {/* Column Header Section  */}
                        <Grid item style={{ marginRight: '7vw' }}>
                          <Grid
                            container
                            direction="column"
                            alignContent="space-between"
                          >
                            <Grid item className={classes.rowStyle}>
                              <Typography variant="body2"> Balance</Typography>
                            </Grid>
                            <Grid item style={{ margin: '25px 0' }}>
                              <Typography variant="body2">
                                {' '}
                                Expected Due Date
                              </Typography>
                            </Grid>
                            {/* <Grid item style={{ margin: '40px 0' }}>
                              <Typography variant="body2"> Remarks</Typography>
                            </Grid> */}
                          </Grid>
                        </Grid>

                        {/*  Hardware Column Data */}
                        {partnerSubscriptionData.billingDetails.hardwareBill ? (
                          <Grid item disabled>
                            <Grid
                              container
                              direction="column"
                              alignContent="space-between"
                            >
                              <Grid item className={classes.rowStyle}>
                                <Typography variant="body1">
                                  &#8377; {hardwareBalance}
                                </Typography>
                              </Grid>
                              <Grid item className={classes.rowStyle}>
                                <DatePicker
                                  disabled={hardwareBalance === 0}
                                  className={classes.dateStyle}
                                  label="Due Date"
                                  value={expectedHardwareDueDate}
                                  // views={['year', 'month', 'date']}
                                  // format="dd/MM/yyyy"
                                  onChange={this.handleExpectedDateChange(
                                    'expectedHardwareDueDate'
                                  )}
                                  format="DD/MM/YYYY"
                                />
                              </Grid>
                              {/* <Grid item className={classes.rowStyle}>
                                <TextField
                                  disabled={hardwareBalance === 0}
                                  id="amount"
                                  className={classes.textFieldStyle}
                                  label=" Remarks "
                                  multiline
                                  value={hardwareRemarks}
                                  onChange={this.handleRemarksChange(
                                    'hardwareRemarks'
                                  )}
                                  margin="none"
                                />
                              </Grid> */}
                            </Grid>
                          </Grid>
                        ) : null}

                        {/*  Software Column Data */}
                        {partnerSubscriptionData.billingDetails.softwareBill ? (
                          <Grid item>
                            <Grid
                              container
                              direction="column"
                              alignContent="space-between"
                            >
                              <Grid item className={classes.rowStyle}>
                                <Typography variant="body1">
                                  &#8377; {softwareBalance}
                                </Typography>
                              </Grid>
                              <Grid item className={classes.rowStyle}>
                                <DatePicker
                                  disabled={softwareBalance === 0}
                                  className={classes.dateStyle}
                                  label="Due Date"
                                  value={expectedSoftwareDueDate}
                                  format="DD/MM/YYYY"
                                  onChange={this.handleExpectedDateChange(
                                    'expectedSoftwareDueDate'
                                  )}
                                  // inputProps={{
                                  //   name: 'expiryDateTime'
                                  // }}
                                />
                              </Grid>
                              {/* <Grid item className={classes.rowStyle}>
                                <TextField
                                  disabled={softwareBalance === 0}
                                  id="amount"
                                  className={classes.textFieldStyle}
                                  label=" Remarks "
                                  multiline
                                  value={softwareRemarks}
                                  onChange={this.handleRemarksChange(
                                    'softwareRemarks'
                                  )}
                                  margin="none"
                                />
                              </Grid> */}
                            </Grid>
                          </Grid>
                        ) : null}

                        {/*  Accessory Column Data */}
                        {partnerSubscriptionData.billingDetails
                          .accessoryBill ? (
                          <Grid item>
                            <Grid
                              container
                              direction="column"
                              alignContent="space-between"
                            >
                              <Grid item className={classes.rowStyle}>
                                <Typography variant="body1">
                                  &#8377; {accessoryBalance}
                                </Typography>
                              </Grid>
                              <Grid item className={classes.rowStyle}>
                                <DatePicker
                                  disabled={accessoryBalance === 0}
                                  className={classes.dateStyle}
                                  label="Due Date"
                                  value={expectedAccessoryDueDate}
                                  onChange={this.handleExpectedDateChange(
                                    'expectedAccessoryDueDate'
                                  )}
                                  format="DD/MM/YYYY"
                                  // inputProps={{
                                  //   name: 'expiryDateTime'
                                  // }}
                                />
                              </Grid>
                              {/* <Grid item className={classes.rowStyle}>
                                <TextField
                                  disabled={accessoryBalance === 0}
                                  id="amount"
                                  className={classes.textFieldStyle}
                                  label=" Remarks "
                                  multiline
                                  value={accessoryRemarks}
                                  onChange={this.handleRemarksChange(
                                    'accessoryRemarks'
                                  )}
                                  margin="none"
                                />
                              </Grid> */}
                            </Grid>
                          </Grid>
                        ) : null}

                        {/*  Sims Column Data */}
                        {partnerSubscriptionData.billingDetails.simBill ? (
                          <Grid item>
                            <Grid
                              container
                              direction="column"
                              alignContent="space-between"
                            >
                              <Grid item className={classes.rowStyle}>
                                <Typography variant="body1">
                                  &#8377; {simBalance}
                                </Typography>
                              </Grid>
                              <Grid item className={classes.rowStyle}>
                                <DatePicker
                                  disabled={simBalance === 0}
                                  className={classes.dateStyle}
                                  label="Due Date"
                                  value={expectedSimsDueDate}
                                  onChange={this.handleExpectedDateChange(
                                    'expectedSimsDueDate'
                                  )}
                                  format="DD/MM/YYYY"
                                  // inputProps={{
                                  //   name: 'expiryDateTime'
                                  // }}
                                />
                              </Grid>
                              {/* <Grid item className={classes.rowStyle}>
                                <TextField
                                  disabled={simBalance === 0}
                                  id="amount"
                                  className={classes.textFieldStyle}
                                  label=" Remarks "
                                  multiline
                                  value={simRemarks}
                                  onChange={this.handleRemarksChange(
                                    'simRemarks'
                                  )}
                                  margin="none"
                                />
                              </Grid> */}
                            </Grid>
                          </Grid>
                        ) : null}
                      </Grid>
                    </CardContent>
                  </Card>
                )}
            </Grid>
            <br />

            {/* Record payment Section */}
            {['ACC'].includes(getAccountType()) && (
              // data.subscription.minimumAmountDue > 0 &&
              <Grid item xs={12}>
                <Card className={classes.card} raised>
                  <CardHeader title="Record Payment" />
                  <CardContent>
                    <Grid container spacing={16}>
                      <Grid item xs={12}>
                        <FormControl className={classes.formControl}>
                          <InputLabel id="payment-helper">
                            Payment Type
                          </InputLabel>

                          <Select
                            value={this.state.paymentMode}
                            onChange={this.handleChangePaymentType}
                            className={classes.selectStyle}
                          >
                            <MenuItem value={'NONE'}>None</MenuItem>
                            <MenuItem value={'CASH'}>Cash</MenuItem>
                            <MenuItem value={'ONLINE'}>Online</MenuItem>
                            <MenuItem value={'CHEQUE'}>Cheque</MenuItem>
                            <MenuItem value={'DD'}>DD</MenuItem>
                          </Select>
                          {/* <FormHelperText>Some important helper text</FormHelperText> */}
                        </FormControl>
                      </Grid>

                      {paymentOption.includes(this.state.paymentMode) && (
                        <Grid item xs={12}>
                          <PaymentMethod
                            paymentThrough={this.state.paymentMode}
                            handleChangereferenceNumber={
                              this.handleChangeReferenceNumber
                            }
                            checkReferenceNumberValidity={
                              this.checkReferenceNumberValidity
                            }
                            isValidReferenceNumber={
                              this.state.isValidReferenceNumber
                            }
                            referenceMessage={this.state.referenceMessage}
                            handleChangeBankName={this.handleChangeBankName}
                            handleChangePaidMoney={this.handleChangePaidMoney}
                            // paidMoney={this.state.paidMoney}
                            referenceNumber={this.state.referenceNumber}
                            bankName={this.state.bankName}
                          />
                        </Grid>
                      )}

                      <Grid item xs={12}>
                        <TextField
                          multiline
                          rows={2}
                          label="Remarks"
                          variant="contained"
                          onChange={this.handleAccountRemarksChange}
                          value={this.state.accountRemarks}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                  <CardActions>
                    <Button
                      variant="contained"
                      color="secondary"
                      classes={{ root: classes.redButton }}
                      onClick={this.handleCancel}
                    >
                      Reject
                    </Button>
                    <Button
                      disabled={!this.state.paymentMode}
                      variant="contained"
                      color="secondary"
                      type="submit"
                      onClick={this.handleSubmit}
                    >
                      Approve
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            )}
          </Grid>
        )}
      </Fragment>
    )
  }
}

export default withStyles(styles)(
  withSharedSnackbar(withApollo(withRouter(PartnerSubscriptionDetail)))
)



// WEBPACK FOOTER //
// ./src/components/Pages/Partner/PartnerSubscriptionDetail.jsx